export default __webpack_public_path__ + "static/media/l-5.3456b2eb.png";